import useBackendErrorQuery from "src/queries/useBackendErrorQuery";

function BackendError() {
  useBackendErrorQuery();

  return null;
}

export default BackendError;
